var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFmShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 100,
    viewBox: "0 0 192 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.746 80.408C10.153 73.807 0 59.12 0 42.063C0 18.833 18.832 0 42.063 0C65.294 0 84.127 18.832 84.127 42.063C84.127 59.015 74.099 73.625 59.652 80.284C51.744 90.574 42.152 99.28 42.152 99.28C42.152 99.28 32.635 90.644 24.746 80.408ZM42.063 77.208C61.473 77.208 77.208 61.473 77.208 42.063C77.208 22.653 61.473 6.918 42.063 6.918C22.653 6.918 6.918 22.653 6.918 42.063C6.918 61.473 22.653 77.208 42.063 77.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1617 44.558C73.6363 52.0013 70.5231 59.0262 65.3617 64.415C63.5887 61.816 60.9677 59.36 57.7257 57.151C53.5897 54.34 48.4007 51.909 42.5117 50.101C45.1567 48.975 47.8658 48.0056 50.6247 47.198C57.2487 45.251 63.7067 44.332 69.4447 44.332C71.0847 44.332 72.6557 44.408 74.1617 44.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8329 28.559C53.6269 25.223 61.3499 23.466 67.9729 23.189C72.0628 28.706 74.2657 35.3943 74.2549 42.262C74.2549 42.369 74.2449 42.477 74.2449 42.59C72.65 42.4398 71.0489 42.3644 69.4469 42.364C64.9769 42.364 60.1209 42.904 55.1069 44.014C51.0019 39.712 44.9279 35.761 37.5859 32.726C40.2443 31.1644 42.9988 29.7726 45.8329 28.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9355 49.5419C13.9145 49.0219 17.1825 48.7389 20.6495 48.7499C24.6814 48.7593 28.7053 49.1082 32.6785 49.7929C42.2655 51.4159 50.6715 54.7249 56.6205 58.7729C59.8685 60.9779 62.3455 63.3879 63.9325 65.8229C58.2135 71.1049 50.5725 74.3369 42.1735 74.3369C26.9645 74.3369 14.2325 63.7469 10.9355 49.5419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6498 46.782C17.0848 46.792 13.6828 47.076 10.5498 47.62C10.2457 45.8482 10.0925 44.0538 10.0918 42.256C10.0918 37.576 11.1048 33.136 12.9028 29.123C17.5318 29.333 22.5148 30.084 27.6178 31.435C38.3608 34.276 47.3628 39.184 52.8658 44.537C51.9348 44.774 51.0048 45.02 50.0708 45.297C46.4438 46.361 43.0048 47.769 39.8408 49.227C37.6008 48.627 35.4068 48.251 33.0078 47.847C28.7428 47.127 24.5878 46.782 20.6498 46.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1268 29.535C23.2048 28.23 18.3797 27.468 13.8438 27.196C19.2378 17.069 29.8997 10.175 42.1737 10.175C51.8737 10.175 60.5617 14.485 66.4507 21.293C59.8887 21.765 52.5008 23.559 45.0557 26.745C41.707 28.1719 38.4667 29.8409 35.3608 31.739C33.0287 30.86 30.6708 30.2071 28.1268 29.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.184 25.5973C106.616 25.5973 105.944 26.2693 105.72 27.8373L100.045 74.1306C99.8214 75.6986 100.419 76.3706 101.987 76.3706H110.051C111.619 76.3706 112.141 75.6986 112.365 74.1306L114.68 55.464H130.509C132.077 55.464 132.824 54.8666 133.048 53.2986L133.795 47.4746C134.019 45.9066 133.421 45.384 131.853 45.384H115.949L117.144 35.6773H134.243C135.811 35.6773 136.483 35.08 136.707 33.512L137.453 27.688C137.677 26.12 137.005 25.5973 135.437 25.5973H108.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.562 27.8373C191.786 26.2693 191.338 25.5973 189.77 25.5973H181.93C180.81 25.5973 180.212 25.896 179.764 26.6426L167.146 49.7893C166.175 51.5813 165.204 53.448 164.383 55.5386C163.935 53.2986 163.487 51.5813 162.89 49.64L155.572 26.792C155.348 26.0453 154.9 25.5973 153.78 25.5973H146.538C144.97 25.5973 144.298 26.2693 144.074 27.8373L138.399 74.1306C138.175 75.6986 138.772 76.3706 140.34 76.3706H147.658C149.226 76.3706 149.748 75.6986 149.972 74.1306L152.884 50.6106C153.258 53.224 153.631 55.464 154.079 56.9573L156.991 66.44C157.439 67.784 158.111 68.68 159.903 68.68H166.026C167.519 68.68 168.49 67.9333 169.236 66.44L173.492 58.3013C174.388 56.6586 175.583 53.8213 176.852 50.3866L173.94 74.1306C173.716 75.6986 174.314 76.3706 175.882 76.3706H183.572C185.14 76.3706 185.663 75.6986 185.887 74.1306L191.562 27.8373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFmShort);
export default __webpack_public_path__ + "static/media/logo-fm-short.7aed2356f8ba45b883513fe8913e045a.svg";
export { ForwardRef as ReactComponent };